var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAcaeMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 120 90",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M95.2,17.1H30.8c-6.3,0-11.4,5.1-11.4,11.4v36.1c0,6.3,5.1,11.4,11.4,11.4h64.3c6.3,0,11.4-5.1,11.4-11.4V28.5c0-6.3-5.1-11.4-11.4-11.4h0ZM99,28.5v36.1c0,2.1-1.7,3.8-3.8,3.8H30.8c-2.1,0-3.8-1.7-3.8-3.8V28.5c0-2.1,1.7-3.8,3.8-3.8h64.3c2.1,0,3.8,1.7,3.8,3.8h0Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M104.6,22.9c-1.1-1.7-3.5-2.3-5.2-1.1l-36.4,24.4L26.6,21.8c-1.7-1.1-4.1-.6-5.2,1.1s-.6,4.1,1.1,5.2l36.2,24.3c2.6,1.7,5.9,1.7,8.5,0l36.2-24.3c1.8-1.1,2.2-3.5,1.1-5.2Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAcaeMail);
export default __webpack_public_path__ + "static/media/acae_mail.bf23bdc2.svg";
export { ForwardRef as ReactComponent };